<template>
   <div :class="{'tw-relative': hasSlot}">
      <div v-if="showBlur" class="tw-absolute tw-backdrop-blur-sm tw-bg-white/10 tw-flex tw-inset-0 tw-items-center tw-justify-center tw-text-center tw-text-gray-700 tw-z-10">
        <h2 v-if="showTitle" class="tw-font-bold tw-text-xl">Indisponível no seu plano</h2>
      </div>
      <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      showBlur: {
        type: Boolean,
        default: false
      },
      showTitle: {
        type: Boolean,
        default: true
      },
    },
    computed: {
      hasSlot() {
        return !!this.$slots.default;
      }
    }
  }
</script>
